import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, Checkbox } from 'rsuite';

const MarkOwnershipModal = ({
  open,
  onClose,
  mode,
  skipProxies,
  onSkipProxiesChange,
  onConfirm,
  loading,
}) => (
  <Modal open={open} onClose={onClose} size="xs">
    <Modal.Header>
      <Modal.Title>
        {mode === 'owned' ? 'Mark All as Owned' : 'Mark All as Unowned'}
      </Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <p>
        {mode === 'owned'
          ? 'Mark all entries in this deck as owned? They will appear in your Collection view on next load.'
          : 'Mark all entries in this deck as unowned? They will be excluded from your Collection view.'}
      </p>
      <div style={{ marginTop: 12 }}>
        <Checkbox
          checked={skipProxies}
          onChange={(_, checked) => onSkipProxiesChange(checked)}
        >
          Skip proxies (leave proxy entries unchanged)
        </Checkbox>
      </div>
    </Modal.Body>
    <Modal.Footer>
      <Button onClick={onClose} appearance="subtle">
        Cancel
      </Button>
      <Button onClick={onConfirm} appearance="primary" loading={loading}>
        {mode === 'owned' ? 'Mark All as Owned' : 'Mark All as Unowned'}
      </Button>
    </Modal.Footer>
  </Modal>
);

MarkOwnershipModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  mode: PropTypes.oneOf(['owned', 'unowned']),
  skipProxies: PropTypes.bool.isRequired,
  onSkipProxiesChange: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

MarkOwnershipModal.defaultProps = {
  mode: 'owned',
  loading: false,
};

export default MarkOwnershipModal;
